import React, { useState, useEffect } from 'react'
import { useTable, useSortBy, useExpanded } from 'react-table-new'
import styled from 'styled-components'
import PaginationNew from './PaginationNew'
import colors from '../../styles/colors'
import sortAscIcon from '../../images/sortAscIcon.svg'
import sortDescIcon from '../../images/sortDescIcon.svg'
import sortIcon from '../../images/sortIcon.svg'

const Table = ({
  columns,
  data,
  page,
  total,
  onPageChange,
  onSortedChange,
  defaultPageSize = 50,
  addAriaLabelToHeader = false,
  renderRowSubComponent,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
  } = useTable(
    {
      manualSortBy: true,
      columns,
      data,
    },
    //useExpanded,
    //useFilters,
    useSortBy,
    useExpanded
  )
  const [hover, setHover] = useState(false)
  const [sorted, setSorted] = useState({
    isSorted: false,
    isSortedDesc: false,
    columnId: '',
  })

  const handleSorting = (column) => {
    if (column.id === sorted.columnId) {
      column.sortable &&
        sorted.isSorted === false &&
        setSorted({ isSorted: true, isSortedDesc: false, columnId: column.id })
      column.sortable &&
        sorted.isSorted === true &&
        sorted.isSortedDesc === false &&
        setSorted({ isSorted: true, isSortedDesc: true, columnId: column.id })
      column.sortable &&
        sorted.isSorted === true &&
        sorted.isSortedDesc === true &&
        setSorted({ isSorted: false, isSortedDesc: false, columnId: column.id })
    } else {
      column.sortable &&
        setSorted({ isSorted: true, isSortedDesc: false, columnId: column.id })
    }
  }
  useEffect(() => {
    const sort =
      (sorted.isSorted === true &&
        sorted.isSortedDesc === false && { [sorted.columnId]: 'asc' }) ||
      (sorted.isSorted === true &&
        sorted.isSortedDesc === true && { [sorted.columnId]: 'desc' }) ||
      {}
    onSortedChange(sort)
  }, [sorted])

  const setAriaLabelToHeaderCell = (column) => {
    if (addAriaLabelToHeader === false || column.sortable === false) {
      return null
    }

    const columnId = column.id
    const columnHeader = column.Header

    if (sorted.isSorted === true) {
      if (sorted.columnId === columnId) {
        if (sorted.isSortedDesc === false) {
          return `${columnHeader} Posortowane rosnąco`
        } else {
          return `${columnHeader} Posortowane malejąco`
        }
      } else {
        return `${columnHeader} Nieposortowane`
      }
    } else {
      return `${columnHeader} Nieposortowane`
    }
  }

  const getPropsWithoutRole = (props) => {
    // odrzucamy "role" ze wzgledu na błąd zglaszany przez walidator html
    const { role, ...otherProps } = props

    return otherProps
  }

  const showPagination = total !== undefined ? defaultPageSize < total : false
  const pages =
    total !== undefined ? Math.ceil(total / defaultPageSize) : undefined

  return (
    // If you're curious what props we get as a result of calling our getter functions (getTableProps(), getRowProps())
    // Feel free to use console.log()  This will help you better understand how react table works underhood.
    <>
      <StyledTable>
        <StyledThead>
          {headerGroups.map((headerGroup) => {
            const {
              key,
              role,
              ...otherHeaderGroupProps
            } = headerGroup.getHeaderGroupProps() // odrzucamy "role" ze wzgledu na błąd zglaszany przez walidator html

            return (
              <StyledTr key={key} {...otherHeaderGroupProps}>
                {headerGroup.headers.map((column) =>
                  column.sortable ? (
                    <SortableStyledTh key={column.id}>
                      <HeaderCell
                        columnIsSortable={column.sortable}
                        {...column.getHeaderProps()}
                        onMouseEnter={() => setHover(column)}
                        onMouseLeave={() => setHover({})}
                        onClick={() => handleSorting(column)}
                        aria-label={setAriaLabelToHeaderCell(column)}
                      >
                        {column.render('Header')}
                        <span>
                          {sorted.isSorted &&
                          !sorted.isSortedDesc &&
                          sorted.columnId === column.id ? (
                            <StyledIcon src={sortAscIcon} />
                          ) : sorted.isSortedDesc &&
                            sorted.columnId === column.id ? (
                            <StyledIcon src={sortDescIcon} />
                          ) : null}
                          {column.id === hover.id && hover.sortable === true
                            ? column.render(<StyledIcon src={sortIcon} />)
                            : null}
                        </span>
                      </HeaderCell>
                    </SortableStyledTh>
                  ) : (
                    <StyledTh key={key} {...otherHeaderGroupProps}>
                      {column.render('Header')}
                    </StyledTh>
                  )
                )}
              </StyledTr>
            )
          })}
        </StyledThead>

        <tbody {...getPropsWithoutRole(getTableBodyProps())}>
          {rows.map((row) => {
            prepareRow(row)
            return (
              <React.Fragment key={row.id}>
                <StyledBodyTr
                  expanded={row.isExpanded}
                  {...getPropsWithoutRole(row.getRowProps())}
                >
                  {row.cells.map((cell) => {
                    const { role, ...otherCellProps } = cell.getCellProps()

                    return (
                      <StyledCell key={cell.value} {...otherCellProps}>
                        {cell.render('Cell')}
                      </StyledCell>
                    )
                  })}
                </StyledBodyTr>
                {row.isExpanded && (
                  <tr>
                    <StyledExpandedRows aria-label="Tabela rozszerzona" colSpan={visibleColumns.length}>
                      {renderRowSubComponent(row)}
                      <StyledWrapper aria-hidden role="none"></StyledWrapper>
                    </StyledExpandedRows>
                  </tr>
                )}
              </React.Fragment>
            )
          })}
        </tbody>
      </StyledTable>
      {showPagination && (
        <PaginationNew
          pages={pages}
          page={page}
          onPageChange={onPageChange}
          previousText={'Wstecz'}
          nextText={'Dalej'}
        />
      )}
    </>
  )
}
export default Table

const StyledTable = styled.table`
  max-width: 100%;
  font-size: 14px;
  color: ${colors.black};
`
const StyledTr = styled.tr`
  line-height: 29px;
  font-weight: 600;
  text-align: left;
  padding: 0 15px;
`
const StyledBodyTr = styled.tr`
  line-height: 29px;
  font-weight: 600;
  ${(props) => props.expanded && `background-color: #eaeaea`};
  text-align: left;
  padding: 0 15px;
  &:hover {
    background-color: #eaeaea !important;
  }
`
const StyledThead = styled.thead`
  line-height: 29px;
  border-radius: 42px;
  border-color: #eaeaea;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  &.-header {
    box-shadow: none;
  }
`
const SortableStyledTh = styled.th`
  border-bottom: 1px solid black;
`
const StyledCell = styled.td`
  font-weight: 100;
  line-height: 38px;
  font-feature-settings: 'lnum';
  font-size: 14px;
`
const HeaderCell = ({ columnIsSortable, colSpan, role, ...props }) => {
  // odrzucamy niektore propsy ze wzgledu na walidator html
  return columnIsSortable === true ? (
    <HeaderCellButton {...props} />
  ) : (
    <StyledTh role={role} {...props} />
  )
}
const StyledTh = styled.th`
  border-bottom: 1px solid black;
`
const HeaderCellButton = styled.button`
  width: fit-content;
  cursor: pointer;
  background: transparent;
  border: none;
`
const StyledIcon = styled.img`
  position: absolute;
  margin: 7px 7px;
`
const StyledWrapper = styled.div`
  height: 100px;
`
const StyledExpandedRows = styled.td`
  font-feature-settings: 'lnum';
  border-left: 4px solid ${colors.monza};
`
